var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 4.833h-4a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h4c.273 0 .5.227.5.5 0 .274-.227.5-.5.5M4 4.833H1.334a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5H4c.274 0 .5.227.5.5 0 .274-.226.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.667 7.167a2.84 2.84 0 0 1-2.833-2.834A2.84 2.84 0 0 1 6.667 1.5 2.84 2.84 0 0 1 9.5 4.333a2.84 2.84 0 0 1-2.833 2.834m0-4.667a1.832 1.832 0 1 0 0 3.667 1.832 1.832 0 1 0 0-3.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.667 2.5a1.832 1.832 0 1 0 0 3.667 1.832 1.832 0 1 0 0-3.667M14.667 12.167H12a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h2.667c.273 0 .5.226.5.5 0 .273-.227.5-.5.5M5.334 12.167h-4a.504.504 0 0 1-.5-.5c0-.274.226-.5.5-.5h4c.273 0 .5.226.5.5 0 .273-.227.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.333 14.5A2.84 2.84 0 0 1 6.5 11.667a2.84 2.84 0 0 1 2.833-2.834 2.84 2.84 0 0 1 2.834 2.834A2.84 2.84 0 0 1 9.333 14.5m0-4.667a1.832 1.832 0 1 0 0 3.667 1.832 1.832 0 1 0 0-3.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.333 9.833a1.832 1.832 0 1 0 0 3.667 1.832 1.832 0 1 0 0-3.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsActive);
export default __webpack_public_path__ + "static/media/settingsActive.4c1e14d75411dbdef6550f5013682a40.svg";
export { ForwardRef as ReactComponent };